import type { FC } from "react";

import { RedirectionLinkCard } from "@ui/components/RedirectionLinkCard";
import classNames from "classnames";

import { Button } from "@jti/core-components/components/Button";

import type { ListProps } from "../List";
import type { ListItemAnchor } from "../types";

import styles from "./ListItem.module.scss";

export type ListItemProps = {
  style: Omit<ListProps["style"], "quick-links">;
  item?: ListItemAnchor;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  enableCookieSettings?: boolean;
};

export const ListItem: FC<ListItemProps> = ({ style, item, onClick, enableCookieSettings }) => {
  return (
    <li
      className={classNames({ [styles.listItemHorizontal]: style === "navigation-horizontal" })}
      data-testid="listItem"
    >
      {style === "navigation" || style === "navigation-horizontal" ? (
        <RedirectionLinkCard link={item?.path ?? ""} title={item?.title ?? ""} />
      ) : (
        <Button
          variant="text"
          href={item?.path ?? ""}
          className={classNames(styles.blueLinkListItem)}
          data-testid="listButton"
          size="lg"
          target={item?.tabBehaviour === "sameTab" ? "_self" : "_blank"}
          id={enableCookieSettings ? "ot-sdk-btn" : ""}
          onClick={onClick}
        >
          {item?.title}
        </Button>
      )}
    </li>
  );
};
